const theme = {
  'accent': '#2BC5C5',
  'surface': '#F5F5F5',
  'panel': '#FFFFFF',
  'sub-panel': '#FAFAFA',
  'border': '#D9D9D9',
  'text': 'rgba(0,0,0,0.88)',
  'text-muted': 'rgba(0,0,0,0.45)',
  'danger': '#FF4D4F',
  'gold': '#FAAD14',
  'danger-text': '#CF1322',
  'primary-button-bg': '#087E7E',
  'primary-hover': '#076D6D',
  'primary-active': '#065C5C',
  'primary-soft': '#E6F7F7',
  'focus-ring': 'rgba(43,197,197,0.4)',
  'disabled-bg': '#FFFFFF',
  'disabled-border': '#D9D9D9',
  'disabled-text': 'rgba(0,0,0,0.45)',
  'overlay': 'rgba(0,0,0,0.64)',
  'shadow': 'rgba(0,0,0,0.12)',
  'radius': '10px',
  'radius-chip': '8px',
  'card-x': '28px',
  'card-y': '20px',
  'mobile-space': '16px',
  'section-gap': '24px',
  'font-title': '20px',
  'font-body': '16px',
  'font-caption': '14px',
  'booking-row-height': '48px',
  'booking-list-height': '336px',
  'booking-list-fade': '12px',
  'booking-step-duration': '200ms',
  'motion-duration': '160ms',
  'motion-enter': 'ease-out',
  'motion-exit': 'ease-in'
};
export default theme;
